<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0" v-if="!idEdit">Realize seu cadastro</h3>
                <h3 class="mb-0" v-else>
                  Cadastro de Profissional Independente
                </h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <b-form @submit.prevent="save" v-loading="loading">
              <!-- Dados de Acesso -->
              <h6 class="heading-small text-muted mb-4">Dados de Acesso</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="email"
                      label="E-mail de Acesso"
                      name="E-mail de Acesso"
                      placeholder="exemplo@email.com"
                      v-model="user.emailAcesso"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="password"
                      label="Senha"
                      name="Senha"
                      placeholder="Digite sua senha"
                      v-model="user.senha"
                      :disabled="idEdit"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Responsável pela inscrição -->
              <h6 class="heading-small text-muted mb-4">
                Responsável pela inscrição
              </h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nome"
                      name="Nome"
                      placeholder="Digite seu nome"
                      v-model="user.nomeResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="email"
                      label="E-mail"
                      name="E-mail"
                      placeholder="exemplo@email.com"
                      v-model="user.emailResponsavel"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o seu cargo na empresa"
                      v-model="user.cargoResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="RG"
                      name="RG"
                      placeholder="00.000.000-0"
                      v-model="user.rgResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Celular"
                      name="Celular"
                      placeholder="(00) 0000-0000"
                      v-model="user.celularResponsavel"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Profissional -->
              <h6 class="heading-small text-muted mb-4">Profissional</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Razão Social"
                      name="Razão Social"
                      placeholder="Digite a razão social da empresa"
                      v-model="user.razaoSocial"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nome Fantasia"
                      name="Nome Fantasia"
                      placeholder="Digite o nome fantasia da empresa"
                      v-model="user.nomeFantasia"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <base-input
                      type="text"
                      label="Endereço da sede"
                      name="Endereço da sede"
                      placeholder="Digite o endereço da sede da empresa"
                      v-model="user.enderecoProfissional"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Cidade"
                      name="Cidade"
                      placeholder="Digite a cidade da empresa"
                      v-model="user.cidadeProfissional"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Telefone"
                      name="Telefone"
                      placeholder="Digite o telefone da empresa"
                      v-model="user.telefoneProfissional"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="email"
                      label="E-mail"
                      name="E-mail"
                      placeholder="Digite o e-mail da empresa"
                      v-model="user.emailProfissional"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <div
                class="pl-lg-4 d-flex justify-content-end align-items-center"
              >
                <span class="text-danger mr-3">{{ errorFeedback }}</span>
                <base-button
                  type="primary"
                  native-type="submit"
                  :loading="loading"
                  class="my-4"
                >
                  <span v-if="!idEdit">Cadastrar</span>
                  <span v-else>Salvar</span>
                </base-button>
              </div>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { login } from "@/services/utils";

export default {
  name: "profissional-independente-form",
  props: {
    userForm: Boolean,
  },
  data() {
    return {
      errorFeedback: "",
      loading: false,
      idEdit: null,
      user: {
        id: "",
        cargoResponsavel: "",
        celularResponsavel: "",
        cidadeProfissional: "",
        emailAcesso: "",
        emailProfissional: "",
        emailResponsavel: "",
        enderecoProfissional: "",
        nomeFantasia: "",
        nomeResponsavel: "",
        razaoSocial: "",
        rgResponsavel: "",
        senha: "",
        telefoneProfissional: "",
      },
    };
  },
  methods: {
    login,
    setLoading(loading) {
      this.loading = loading;
    },
    successLogin() {
      this.$router.push("/usuario");
    },
    errorLogin() {
      this.errorFeedback =
        "Ocorreu algum problema ao fazer login com o usuário criado.";
    },
    async save() {
      this.errorFeedback = "";
      this.loading = true;
      try {
        await api.post("/profissional-independente", this.user);
        if (this.userForm) {
          this.errorFeedback = "";
          login(
            this.user.emailAcesso,
            this.user.senha,
            this.setLoading,
            this.successLogin,
            this.errorLogin
          );
        }
      } catch (e) {
        this.errorFeedback =
          "Ocorreu um problema. Por favor, tente novamente mais tarde.";
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;
    if (this.idEdit) {
      this.loading = true;
      try {
        const response = await api.get(
          `/profissional-independente/${this.idEdit}`
        );
        this.user = response.data;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    } else if (this.$route.params.email) {
      this.user.emailAcesso = this.$route.params.email;
      this.user.senha = this.$route.params.password;
    }
  },
};
</script>
<style></style>
